import svgSrc from './shop-icon.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
}

export const ShopIcon = ({width = "54px", alt = "Shop icon", ...props}: ImageProps) => <div {...props}><img src={svgSrc} width={width} alt={alt} /></div>
export default ShopIcon;